module.exports = __webpack_public_path__ + "img/npc.ed3e3add.gif";